var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',_vm._b({staticStyle:{"border":"none"},attrs:{"src":_vm.resource.url,"loading":"lazy","allow":"accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;","allowfullscreen":"true"}},'iframe',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }